import React from 'react'
import { Table, Dropdown, Button } from "semantic-ui-react"


function MappingDropdown({order, a, onSaveMapping}) {
  const aiItems = order.order_services.map(os => os.ai_details).flat()
  const asOptions = aiItems.filter(ai => ai).map(ai => ({
    key: ai.productCode.description,
    text: ai.productCode.description,
    value: ai.productCode.description
  }))

  return <Dropdown fluid selection options={asOptions} onChange={(event, syntheticEvent) => onSaveMapping(event, syntheticEvent, a.name)} />
}

function Row({a, order, onSaveMapping}) {
  return <Table.Row>
            <Table.Cell>{a.name}</Table.Cell>
            <Table.Cell>{a.amount}</Table.Cell>
            <Table.Cell>{a.discount}</Table.Cell>
            <Table.Cell>{a.units}</Table.Cell>
            <Table.Cell>{a.unit_price}</Table.Cell>
            <Table.Cell>{a.order_service_name}</Table.Cell>
            <Table.Cell>{a.ai_desc ? a.ai_desc : <MappingDropdown order={order} a={a} onSaveMapping={onSaveMapping}/>}</Table.Cell>
         </Table.Row>
}

export default function TransactionsTab({order, onSaveMapping, onSubmitMapping}) {
  
  return <React.Fragment>
            {order.invoice_line_items.length === 0 && (
              <div>
                <em>No invoice line items recorded. This may be a legacy order, or one that hasn't paid yet, or is unreconciled.</em>
              </div>
            )}
            {order.invoice_line_items.length !== 0 && (
              <React.Fragment>
                <Table
                  striped
                  celled
                  selectable
                  style={{ marginTop: "1em", marginBottom: "5px" }}
                >
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>Invoice Item</Table.HeaderCell>
                      <Table.HeaderCell>Amount</Table.HeaderCell>
                      <Table.HeaderCell>Discount</Table.HeaderCell>
                      <Table.HeaderCell>Units</Table.HeaderCell>
                      <Table.HeaderCell>Unit Price</Table.HeaderCell>
                      <Table.HeaderCell>Mapped to</Table.HeaderCell>
                      <Table.HeaderCell>Via AI Item</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {order.invoice_line_items.map(a => <Row a={a} order={order} onSaveMapping={onSaveMapping} />)}
                    <Table.Row>
                      <Table.Cell></Table.Cell>
                      <Table.Cell></Table.Cell>
                      <Table.Cell></Table.Cell>
                      <Table.Cell></Table.Cell>
                      <Table.Cell></Table.Cell>
                      <Table.Cell></Table.Cell>
                      <Table.Cell><Button primary onClick={onSubmitMapping}>Save Mappings</Button></Table.Cell>
                   </Table.Row>
                  </Table.Body>
                </Table>
              </React.Fragment>
            )}
          </React.Fragment>
}